import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import { useTranslation } from "react-i18next";
import { useVersionCheck } from "../version-check/useVersionCheck.ts";

export function UpdateSnackbar() {
  const { updateAvailable, reload } = useVersionCheck();
  const { t } = useTranslation();

  return (
    <Snackbar open={updateAvailable} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity="info"
        variant="filled"
        // xs で minWidth 360 を効かせると、モバイル幅では Snackbar の枠 (画面幅 - 左右 8px)
        // を超えて CTA が画面外に切れる。そのため minWidth は sm 以上でのみ効かせる。
        sx={{ minWidth: { xs: "auto", sm: 360 } }}
        // 幅に余裕が無いときも CTA は折り返さず 1 行に保つ。
        action={
          <Button color="inherit" size="small" onClick={reload} sx={{ whiteSpace: "nowrap" }}>
            {t("appUpdate.cta")}
          </Button>
        }
      >
        <AlertTitle>{t("appUpdate.title")}</AlertTitle>
        {t("appUpdate.body")}
      </Alert>
    </Snackbar>
  );
}
